import { useRef } from "react"
import { Select } from "source/shared/components"
import {
  ChurchCenterCustomFieldApiRecordWithRelationships,
  UpdateCustomFieldAttributes,
} from "source/myChurchCenter/Profile/types"
import { Icon } from "source/shared/components"

export function Boolean({
  customField,
  updateAttributes,
}: {
  customField: ChurchCenterCustomFieldApiRecordWithRelationships
  updateAttributes: UpdateCustomFieldAttributes
}) {
  const fieldName =
    customField.relationships.field_definition.data.attributes.name
  const fieldValue =
    customField.relationships.field_data?.data[0]?.attributes?.value

  const valueRef = useRef(fieldValue)

  const {
    attributes: { editing_rules: editingRules },
  } = customField

  const disabled =
    editingRules === "view" ||
    !!(editingRules === "add_if_blank" && valueRef.current)
  return (
    <div key={customField.id}>
      <div className="d-f">
        <label htmlFor={fieldName}>{fieldName}</label>
        {disabled && <Icon symbol="general#lock" className="fs-2 pl-1 pt-1" />}
      </div>
      <Select
        disabled={disabled}
        name={fieldName}
        onChange={(e) =>
          updateAttributes({
            customField,
            record: customField.relationships.field_data?.data[0] || null,
            attributes: { value: e.target.value },
          })
        }
        value={fieldValue || ""}
        options={[
          { label: "Select...", value: "" },
          { label: "Yes", value: "true" },
          { label: "No", value: "false" },
        ]}
      />
    </div>
  )
}
